import { alpha, styled } from '@mui/material/styles';

/**
 * Styled wrapper for the stream preview (thumbnails, brush, focus markers).
 * Forwards all div attributes (e.g. data-testid, data-range-from, data-range-to).
 */
export const PreviewWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(2),
  '& .selection': {
    fill: alpha(theme.palette.success.main, 0.25),
    fillOpacity: 1,
    shapeRendering: 'crispEdges',
  },
  '& .preview__selection__handle': {
    fill: theme.palette.success.main,
    cursor: 'ew-resize',
  },
  '& .handle': {
    fill: theme.palette.success.main,
  },
  '& .preview__brush': {
    '& .handle--e, & .handle--w': {
      fill: theme.palette.success.main,
    },
  },
}));
